// src/components/ui/card.jsx
import * as React from "react"
import { cn } from "@/lib/utils"

const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6",
      className
    )}
    {...props}
  />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5", className)}
    {...props}
  />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      "text-base font-semibold text-white leading-none tracking-tight",
      className
    )}
    {...props}
  />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-[#a0a0a0]", className)}
    {...props}
  />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center pt-0", className)}
    {...props}
  />
))
CardFooter.displayName = "CardFooter"

// Card with header section
const CardWithHeader = React.forwardRef(({ className, title, action, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl overflow-hidden",
      className
    )}
    {...props}
  >
    <div className="px-6 py-4 border-b border-[#2a2a2a] flex items-center justify-between">
      <h3 className="text-base font-semibold text-white">{title}</h3>
      {action && <div>{action}</div>}
    </div>
    <div className="p-6">{children}</div>
  </div>
))
CardWithHeader.displayName = "CardWithHeader"

// Interactive/Clickable Card
const CardInteractive = React.forwardRef(({ className, onClick, ...props }, ref) => (
  <div
    ref={ref}
    onClick={onClick}
    className={cn(
      "bg-[#1a1a1a] border border-[#2a2a2a] hover:border-[#3a3a3a] rounded-xl p-6",
      "cursor-pointer transition-colors",
      className
    )}
    {...props}
  />
))
CardInteractive.displayName = "CardInteractive"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent, CardWithHeader, CardInteractive }